import { motion } from "framer-motion";
import Header from './layout/Header';

export default function DetailSkeleton() {
  return (
    <>
      <Header />
      <div className="max-w-6xl mx-auto mt-24 p-4">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.4 }}
          className="grid grid-cols-1 md:grid-cols-2 gap-8"
        >
          {/* LEFT: Image skeleton */}
          <div className="space-y-4">
            <div className="w-full h-[400px] rounded-2xl shimmer" />

            {/* thumbnails */}
            <div className="flex gap-3">
              {[...Array(4)].map((_, i) => (
                <div key={i} className="w-20 h-20 rounded-xl shimmer" />
              ))}
            </div>
          </div>

          {/* RIGHT: Info skeleton */}
          <div className="space-y-4">
            {/* title */}
            <div className="h-7 w-3/4 rounded shimmer" />

            {/* price */}
            <div className="h-8 w-40 rounded shimmer" />

            {/* condition */}
            <div className="h-6 w-24 rounded-full shimmer" />

            {/* description lines */}
            <div className="space-y-2 pt-2">
              <div className="h-4 w-full rounded shimmer" />
              <div className="h-4 w-full rounded shimmer" />
              <div className="h-4 w-5/6 rounded shimmer" />
            </div>

            {/* buttons */}
            <div className="flex gap-3 pt-4">
              <div className="h-12 w-40 rounded-xl shimmer" />
              <div className="h-12 w-32 rounded-xl shimmer" />
            </div>
          </div>
        </motion.div>
      </div>
    </>
  );
}
